import { jsx as _jsx } from "react/jsx-runtime";
import { CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { useMemo } from 'react';
import { useTableSelector } from '../../redux/reduxHooks';
import { makeGetIsColumnVisible, makeGetIsRowVisible } from '../../virtualization/redux/visibleCellsSlice';

const Cell = ({
  CellComponent,
  columnIndex,
  rowIndex,
  columnNamespace,
  columnName,
  rowId,
  row,
  numberOfFrozenColumns = 0
}) => {
  const getIsColumnVisible = useMemo(() => makeGetIsColumnVisible(columnIndex), [columnIndex]);
  const getIsRowVisible = useMemo(() => makeGetIsRowVisible(rowIndex), [rowIndex]);
  const isColumnVisible = useTableSelector(getIsColumnVisible);
  const isRowVisible = useTableSelector(getIsRowVisible); // HACK: These selectors are required for compatibility with onboarding tours
  // and coaching tips. When we've renamed the contact "name" column to it's
  // more permanent placeholder name, we should remove this and PR onboarding
  // tours/coaching tips to use the standardaized selectors.

  const onboardingSelectors = columnNamespace === CONTACT_TYPE_ID && ['name', 'email'].includes(columnName) ? {
    'data-onboarding': `contact-${columnName}-cell`
  } : {}; // This id is part of our external api and should not be changed.
  // It will be used for features like coaching tips and onboarding tours.

  const externalId = `cell-${columnNamespace}-${columnName}-${rowId}`;
  const requiredCellProps = Object.assign({
    'data-table-external-id': externalId,
    'data-test-id': externalId
  }, onboardingSelectors);

  if (!isColumnVisible || !isRowVisible) {
    return /*#__PURE__*/_jsx("td", Object.assign({}, requiredCellProps));
  }

  return /*#__PURE__*/_jsx(CellComponent, {
    columnIndex: columnIndex,
    columnNamespace: columnNamespace,
    columnName: columnName,
    row: row,
    requiredCellProps: requiredCellProps,
    numberOfFrozenColumns: numberOfFrozenColumns
  });
};

export default Cell;